import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { locumsFeatureKey, reducers } from './reducers';
import { LocumsJobEffects } from './effects/job.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(locumsFeatureKey, reducers),
        EffectsModule.forFeature([LocumsJobEffects])
    ]
})
export class LocumsStoreModule {}
